import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import Tooltip from '@mui/material/Tooltip';
import utils from 'helpers/utils';

const StyledTooltip = styled(({className, children, ...props}) => (
  <Tooltip classes={{ tooltip: className }} {...props}>{children}</Tooltip>
))
  .attrs((props) => {
    let attr = props;

    const vars = {
      '--tooltip-emphasis-color': props.theme.property(`palette.${props.$emphasisColor}`)
    };

    return utils.styleProps(attr, vars);
  })`
  color: ${props => props.theme.property('palette.background.default')};
  font-size: ${props => props.theme.fontSize(11)};

  > * {
    overflow-y: scroll;
    max-height: min(${props => props.theme.layout(480)}, 52vh);
    
    .Link {
      color: ${props => props.$css.$var('--tooltip-emphasis-color', false)};
    }
  }
  
  // variant
  &.Tooltip {
    &-light {
      color: ${props => props.theme.property('palette.text.primary')};
      
      background-color: ${props => props.theme.property('palette.background.default')};
      box-shadow: ${props => props.theme.property('shadows.2')};
      
      .MuiTooltip-arrow {
        color: ${props => props.theme.property('palette.background.default')};
        
        &:before {
          box-shadow: ${props => props.theme.property('shadows.1')};
        }
      }
    }
    
    &-emphasis {
      em, mark {
        font-style: normal;
        color: ${props => props.$css.$var('--tooltip-emphasis-color', false)};
      }
    }
  }
  
  ${ComponentStyles}
`;

StyledTooltip.propTypes = {
  theme: PropTypes.object
};

export default StyledTooltip;
